// extracted by mini-css-extract-plugin
module.exports = {"root":"DataWithLabel_root__12v9Y","label":"DataWithLabel_label__1bvs9","list":"DataWithLabel_list__1geRF","value":"DataWithLabel_value__3VcZR"};